class LocationListModel {
  constructor({
    count = null,
    warehouseList = [],
    total = null,
    pageSize = null,
    current = null,
  } = {}) {
    this.count = count;
    this.warehouseList = warehouseList.map(
      (warehouse) => new WarehouseList(warehouse)
    );
    this.total = total;
    this.pageSize = pageSize;
    this.current = current;
  }

  static fromJson(json) {
    return new LocationListModel({
      count: json.count ?? null,
      warehouseList: json.warehouse_list
        ? json.warehouse_list.map((item) => WarehouseList.fromJson(item))
        : [],
      total: json.total ?? null,
      pageSize: json.page_size ?? null,
      current: json.current ?? null,
    });
  }

  toJson() {
    return {
      count: this.count,
      warehouse_list: this.warehouseList.map((warehouse) => warehouse.toJson()),
      total: this.total,
      page_size: this.pageSize,
      current: this.current,
    };
  }
}

class WarehouseList {
  constructor({
    locationId = null,
    locationName = null,
    companyId = null,
    companyName = null,
    countryId = null,
    territory = null,
    cityId = null,
    city = null,
    locationAddress = null,
    landmark = null,
    state = null,
    postalArea = null,
    locationCode = null,
    locationCountryCode = null,
    locationTypeCode = null,
    locationType = null,
    phoneCode = null,
    latitude = null,
    longitude = null,
    phoneNumber = null,
    email = null,
    pickupTime = null,
    workflowId = null,
    workflowCode = null,
    assignedDriver = null,
    assignedDriverUid = null,
    updated = null,
  } = {}) {
    this.locationId = locationId;
    this.locationName = locationName;
    this.companyId = companyId;
    this.companyName = companyName;
    this.countryId = countryId;
    this.territory = territory;
    this.cityId = cityId;
    this.city = city;
    this.locationAddress = locationAddress;
    this.landmark = landmark;
    this.state = state;
    this.postalArea = postalArea;
    this.locationCode = locationCode;
    this.locationCountryCode = locationCountryCode;
    this.locationTypeCode = locationTypeCode;
    this.locationType = locationType;
    this.phoneCode = phoneCode;
    this.latitude = latitude;
    this.longitude = longitude;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.pickupTime = pickupTime;
    this.workflowId = workflowId;
    this.workflowCode = workflowCode;
    this.assignedDriver = assignedDriver;
    this.assignedDriverUid = assignedDriverUid;
    this.updated = updated;
  }

  static fromJson(json) {
    return new WarehouseList({
      locationId: json.location_id ?? null,
      locationName: json.location_name ?? null,
      companyId: json.company_id ?? null,
      companyName: json.company_name ?? null,
      countryId: json.country_id ?? null,
      territory: json.territory ?? null,
      cityId: json.city_id ?? null,
      city: json.city ?? null,
      locationAddress: json.location_address ?? null,
      landmark: json.landmark ?? null,
      state: json.state ?? null,
      postalArea: json.postal_area ?? null,
      locationCode: json.location_code ?? null,
      locationCountryCode: json.location_country_code ?? null,
      locationTypeCode: json.location_type_code ?? null,
      locationType: json.location_type ?? null,
      phoneCode: json.phone_code ?? null,
      latitude: json.latitude ?? null,
      longitude: json.longitude ?? null,
      phoneNumber: json.phone_number ?? null,
      email: json.email ?? null,
      pickupTime: json.pickup_time ?? null,
      workflowId: json.workflow_id ?? null,
      workflowCode: json.workflow_code ?? null,
      assignedDriver: json.assigned_driver ?? null,
      assignedDriverUid: json.assigned_driver_uid ?? null,
      updated: json.updated ?? null,
    });
  }

  toJson() {
    return {
      location_id: this.locationId,
      location_name: this.locationName,
      company_id: this.companyId,
      company_name: this.companyName,
      country_id: this.countryId,
      territory: this.territory,
      city_id: this.cityId,
      city: this.city,
      location_address: this.locationAddress,
      landmark: this.landmark,
      state: this.state,
      postal_area: this.postalArea,
      location_code: this.locationCode,
      location_country_code: this.locationCountryCode,
      location_type_code: this.locationTypeCode,
      location_type: this.locationType,
      phone_code: this.phoneCode,
      latitude: this.latitude,
      longitude: this.longitude,
      phone_number: this.phoneNumber,
      email: this.email,
      pickup_time: this.pickupTime,
      workflow_id: this.workflowId,
      workflow_code: this.workflowCode,
      assigned_driver: this.assignedDriver,
      assigned_driver_uid: this.assignedDriverUid,
      updated: this.updated,
    };
  }
}

export { LocationListModel };
